module.exports = __webpack_public_path__ + "static/media/promotionHeaderImg.89590563.png";